function initDatePicker() {
    const now = new Date();

    if (!$.datepicker) return;

    const frenchstrings = {
        closeText: 'Fermer',
        prevText: 'Précédent',
        nextText: 'Suivant',
        currentText: 'Aujourd\'hui',
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        weekHeader: 'Sem.',
        firstDay: 1,
    }

    $('.datepicker').datepicker({
        altField: "#datepicker",
        ...frenchstrings,
        changeMonth: true,
        changeYear: true,
        yearRange: `${now.getFullYear() - 120}:${now.getFullYear() + 10}`,
        timeFormat: 'HH:mm',
        dateFormat: 'dd/mm/yy',
    });
    $('.datetimepicker').datetimepicker({
        ...frenchstrings,
        changeMonth: true,
        changeYear: true,
        yearRange: `${now.getFullYear() - 120}:${now.getFullYear() + 10}`,
        timeFormat: 'HH:mm',
        dateFormat: 'dd/mm/yy',
    });
    $('.timepicker').timepicker({
        timeFormat: 'HH:mm',
        dateFormat: 'dd/mm/yy',
    });
}
// $.datepicker.regional["fr"]
$(document).ready(initDatePicker);
